import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, onBeforeMount, onBeforeUnmount } from 'vue';
import { TranslateResult } from 'vue-i18n';

type BeforeLeaveFunction = () => boolean | Promise<boolean>;

export type WizardStep = Vue & {
  title: string;
  allowNextIf: boolean;
  beforeLeave: BeforeLeaveFunction;
  hidden: boolean;
  loading: boolean;
  enter: (fromPreviousPage: boolean) => void;
  leave: (toPreviousPage: boolean) => void;
};

/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'WizardStep',
  props: {
    title: null,
    allowNextIf: { type: Boolean, default: true },
    beforeLeave: { type: Function, default: () => () => true },
    hidden: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  emits: ["enter", "leave"],
  setup(__props: any, { expose, emit }: { emit: ((e: 'enter' | 'leave', fromPreviousPage: boolean) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { title: string | TranslateResult, allowNextIf: boolean, beforeLeave: () => boolean | Promise<boolean>, hidden: boolean, loading: boolean };





const refreshSteps = inject<() => void>('refreshSteps');

onBeforeMount(() => {
  refreshSteps?.();
});

onBeforeUnmount(() => {
  refreshSteps?.();
});

function enter(fromPreviousPage: boolean) {
  emit('enter', fromPreviousPage);
}

function leave(toPreviousPage: boolean) {
  emit('leave', toPreviousPage);
}

const title = computed(() => props.title);
const allowNextIf = computed(() => props.allowNextIf);
const beforeLeave = computed(() => props.beforeLeave);
const hidden = computed(() => props.hidden);
const loading = computed(() => props.loading);

expose({
  title,
  allowNextIf,
  beforeLeave,
  hidden,
  loading,
  enter,
  leave,
  isWizardStep: true,
});


return { __sfc: true,props, emit, refreshSteps, enter, leave, title, allowNextIf, beforeLeave, hidden, loading }
}

})